import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface SubscriptionStatusLabelProps {
  active: boolean;
}

export default function SubscriptionStatusLabel({ active }: SubscriptionStatusLabelProps) {
  const { t } = useTranslation();

  const className = active ? 'text-emerald-600' : 'text-red-600';

  return (
    <span className={classNames(
      'font-medium',
      className,
    )}>
      {active ? t('backend:active') : t('backend:ended')}
    </span>
  );
}
